import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import SrButton, {
  SR_BUTTON_THEME_ADOBE_WHITE_BLUE_BORDER,
} from 'client/components/SrButton/SrButton';
import SrFormikErrorMessage from 'client/components/SrFormikErrorMessage';
import SrBox from 'client/components/SrBox';

import './SrSunSetupDriverJobPage.less';

const SrSunSetupDriverJobMediaPhotos = ({ listingId, driverId, jobOrderId, jobId, formikBag }) => {
  const history = useHistory();
  const clpBackUrl = `/sunsetup/drivers/${driverId}/orders/${jobOrderId}/jobs/${jobId}`;

  return (
    <div styleName='card' className='fieldsContainer' id='field-listingPhotoUrls'>
      <span styleName='cardTitle'>
        Upload Photos
      </span>
      <SrBox paddingTop='16px'>
        <SrButton
          theme={SR_BUTTON_THEME_ADOBE_WHITE_BLUE_BORDER}
          hasBoxShadow
          type='button'
          onClick={() => {
            history.push(
              `/photographer/edit-listing/${listingId}?` +
              `backUrl=${global.encodeURIComponent(clpBackUrl)}`
            );
          }}
        >
          Go to Link
        </SrButton>
      </SrBox>
      <SrFormikErrorMessage
        id='listingPhotoUrls'
        formikBag={formikBag}
      />
    </div>
  );
};

SrSunSetupDriverJobMediaPhotos.propTypes = {
  listingId: PropTypes.number.isRequired,
  driverId: PropTypes.number.isRequired,
  jobOrderId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired,
};

SrSunSetupDriverJobMediaPhotos.displayName = 'SrSunSetupDriverJobMediaPhotos';

export default SrSunSetupDriverJobMediaPhotos;
